$ = require 'jquery'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
log = require 'app/scripts/debug/log'

module.exports = class CollectionView extends View
  initialize: ->
    @listenPropagators = {}
    @listenTo @collection,
      'sort': @sort
      'add': @addModel
      'remove': @removeModel
      'reset': @reset

    super

  getModels: ->
    @collection.models

  # Override the subview method to register a blanket listener that will
  # propagate all subview-triggered events to trigger on the CollectionView.
  subview: ->
    view = super
    # @subview gets called a lot, so make sure we only register this once
    @listenPropagators[view.cid] ?=
      @listenTo view, 'all', (event, args...) =>
        @trigger(event, view, args...)
    return view

  addModel: (model, options) ->
    log('render', "adding #{@collection.model.name} to #{@viewType.name}")
    view = @subview(@viewType, model)
    if @el
      @insertSubview(view, _.indexOf(@getModels(), model))
    return

  removeModel: (model, options) ->
    log('render', "removing #{@collection.model.name} from #{@viewType.name}")
    @removeSubview @viewForModel(model)

  reset: (collection, { previousModels }) ->
    keptModels = {}
    for model in collection.models
      keptModels[model.cid] = true
    for model in previousModels when !keptModels[model.cid]
      @removeModel(model)
    @sort()

  sort: ->
    for model, index in @getModels()
      @moveSubviewToPosition(@subview(@viewType, model), index)

    return

  render: ->
    log('render', "rendering #{@getModels().length} #{@collection.model.name}s into #{@viewType.name}")
    @appendSubviews(@subview(@viewType, model) for model in @getModels())
    @

  viewForModel: (model) ->
    @existingSubview @viewType, model

  removeSubview: (subview) ->
    @deleteSubview subview

  insertSubview: (subview, target, $el = @$el) ->
    log('render', "inserting #{ subview.$el.find('h2').text() } at position #{ target }")
    # Turn target from an index or a view into an element
    if typeof target == "number"
      if target <= 0
        target = $el.children().eq(0)
      else if target < $el.children().length
        target = $el.children().eq(target)
      else
        target = undefined
    else if target instanceof View
      target = target.$el

    if subview.$el.is(':empty')
      # If the subview's $el is empty, it hasn't been rendered, so render it
      subview.delegateEvents()
      subview.render()

    if target?.length > 0
      subview.$el.insertBefore(target)
    else
      $el.append(subview.$el)

    return

  moveSubviewToPosition: (subview, position, $el = @$el) ->
    if subview.$el.is(':empty')
      # If the subview hasn't been rendered, it needs to also be inserted
      @insertSubview subview, position, $el
      return

    # When moving things around consecutively, the update for a move triggers
    # a sort action while the placeholder for the current move is still there.
    # This keeps the placeholder in the same location while ensuring the
    # correct location of the other items in the collection.
    for ignored in $el.children('.placeholder,.card-composer') when $(ignored).index() <= position
      position++

    currentPosition = subview.$el.index()
    return if currentPosition == position

    log('render', "moving #{ subview.$el.find('h2').text() } into position #{ position }")

    if position == 0
      $el.prepend(subview.$el)
    else if position >= $el.children().length
      $el.append(subview.$el)
    else
      subview.$el.insertAfter($el.children().eq(position - 1))

    return
